/**
 * @generated SignedSource<<7699b617dc76d3f90f30aecce18c8707>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorSeoAuthor$data = {
  readonly bio: string | null | undefined;
  readonly entityId: string;
  readonly name: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseDynamicMetaTags">;
  readonly " $fragmentType": "authorSeoAuthor";
};
export type authorSeoAuthor$key = {
  readonly " $data"?: authorSeoAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorSeoAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorSeoAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseDynamicMetaTags"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "7a4ad9a6a3cc67c214ba904c43db5763";

export default node;
